// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1a_au","toggleWrap":"styles_toggleWrap__3H7cn","content":"styles_content__2bWRy","selectAreaCode":"styles_selectAreaCode__2cvmw"};